export default __webpack_public_path__ + "static/media/beetleShirt.fe5e292f.jpg";